/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'download': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M7.394 16.795l8.001 6.1.606.462.607-.462 7.998-6.1-1.212-1.59L17 20.079V6.453a1 1 0 10-2 0V20.08l-6.395-4.875-1.212 1.59zm-.521 9.086a1 1 0 100 2h18.255a1 1 0 100-2H6.873z" _fill="#EF7812"/>'
  }
})
